import type { FaireProductEntity } from "../../entity_types/product";

export const p_825ixc01tf: FaireProductEntity = {
  token: "p_825ixc01tf",
  type: "product",
  name: "Adam Turman - Minnesota Abbey Road Socks (Mn) | Funatic",
  brandName: "Funatic - About Face Designs - Nice Enough Merch Co",
  imageUrl:
    "https://cdn.faire.com/fastly/5e35bb6a6a73917e50021ef7f8ab17eef06e19308714d56f8263a438fefec887.jpeg",
  priceDollars: 5.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4105afcdc2de9dcddd41cb77c3e16818779fa6ce2545c78505198e0336f82bc2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
